import React from 'react';
import ReactSelect from 'react-select';

type WorkflowSearchFormFieldFilterProps = {
    filters: any;
    operators: any;
    values: any;
    onChange: (field: string, value: any) => void;
    filterValues: any;
};

export const WorkflowSearchFormFieldFilter: React.FunctionComponent<WorkflowSearchFormFieldFilterProps> = ({
                                                                                                               filters = [],
                                                                                                               operators = [],
                                                                                                               values = [],
                                                                                                               onChange,
                                                                                                               filterValues = {},
                                                                                                           }) => {

    return (
        <div>
            <div className="flex-line-break"/>
            <div className="react-select-fixed-width">
                <ReactSelect
                    placeholder="Select a Field"
                    isSearchable={true}
                    isClearable={true}
                    value={filterValues?.workflowField}
                    options={filters.sort((a: any, b: any) => a.text.localeCompare(b.text)).map((filter: any) => ({
                        ...filter,
                        value: filter.key,
                        label: filter.text
                    }))}
                    onChange={(option: any, type: any) => {
                        onChange && onChange(
                            'workflowField',
                            type.action === 'clear' ? {} : option
                        );
                    }}
                />
            </div>

            {operators.length > 0 &&
            <div style={{display: 'inline-block'}}>
                <div className="react-select-fixed-width pl-4">
                    <ReactSelect
                        placeholder="Operator"
                        isSearchable={true}
                        isClearable={true}
                        value={filterValues?.workflowFieldOperator}
                        options={operators.map((operator: any) => ({
                            value: operator,
                            label: operator
                        }))}
                        onChange={(option: any, type: any) => {
                            onChange && onChange(
                                'workflowFieldOperator',
                                type.action === 'clear' ? {} : option
                            );
                        }}
                    />
                </div>

                {values.length > 0 ?
                    <div className="pl-4 react-select-fixed-width">
                        <ReactSelect
                            placeholder="Field Value"
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={filterValues?.workflowFieldSearchValueOption}
                            options={values.map((value: any) => ({
                                value: value.value,
                                label: value.text
                            }))}
                            onChange={(option: any, type: any) => {
                                onChange && onChange(
                                    'workflowFieldSearchValueOption',
                                    type.action === 'clear' ? {} : option
                                );
                            }}
                        />
                    </div>
                    :
                    <input className="form-control ml-4"
                           style={{marginTop: '-3px', width: '300px'}}
                           value={filterValues?.workflowSearchFieldValueText || ''}
                           onChange={(e) => {
                               onChange && onChange('workflowSearchFieldValueText', e.target.value);
                           }}
                    />
                }
                {/*
                <button className="btn btn-link text-muted"
                        onClick={() => {
                        }}
                >
                    <i className="fas fa-plus"/>
                </button>
                */}
            </div>
            }
        </div>
    );
};